// extracted by mini-css-extract-plugin
export default {"editorSwitch":"yv7V9T5_RxS0u7uSQClF"};